import { render, staticRenderFns } from "./CreateAssistant.vue?vue&type=template&id=960b1632&"
import script from "./CreateAssistant.vue?vue&type=script&lang=js&"
export * from "./CreateAssistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports